import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { SecondMs } from 'rev-shared/date/Time.Constant';

import { VideoStatus } from 'rev-shared/media/VideoStatus';

import styles from './VideoPlaybackProcessingProgressBar.module.less';

const PROCESSING_COMPLETE_DELAY: number = 5 * SecondMs;

@Component({
	selector: 'video-playback-processing-progress-bar',
	templateUrl: './VideoPlaybackProcessingProgressBar.Component.html'
})
export class VideoPlaybackProcessingProgressBarComponent implements OnChanges {
	@Input() public isProcessing: boolean;
	@Input() public overallProgress: number;
	@Input() public videoId: string;
	@Input() public videoStatus: string;

	public readonly styles = styles;

	public processingCompleteTimeout: number;

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.isProcessing) {
			if (this.isProcessing === false &&
				this.isProcessing !== changes.isProcessing.previousValue) {
				this.processingCompleteTimeout = window.setTimeout(() => this.clearProcessingCompleteTimeout(), PROCESSING_COMPLETE_DELAY);
			}

			if (this.isProcessing) {
				this.clearProcessingCompleteTimeout();
			}
		}

		if (changes.videoId) {
			this.clearProcessingCompleteTimeout();
		}
	}

	public get isProcessingFailed(): boolean {
		return this.videoStatus === VideoStatus.PROCESSING_FAILED || this.videoStatus === VideoStatus.READY_BUT_PROCESSING_FAILED;
	}

	private clearProcessingCompleteTimeout(): void {
		window.clearTimeout(this.processingCompleteTimeout);
		this.processingCompleteTimeout = null;
	}
}
